import React, { Component, useEffect, useState } from 'react';
// import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import PhoneNumber from './PhoneNumber';
import VerificationCode from './VerificationCode';
import useUser from '../../../stores/useUser';
import Success from './Success';
import { IPropertyWizardInput } from '../NewPropertyWizard';
import WelcomeText from './WelcomeText';

export interface IModalStepsProps extends IPropertyWizardInput {
    moderationState?: string;
}

const ModalSteps: React.FC<React.PropsWithChildren<IModalStepsProps>> = ({ step, data, onChange, isLoading, moderationState }) => {
    const [user] = useUser();
    const [modalStep, setModalStep] = useState(1);
    const [prefix] = useState('+49');
    const [phone, setPhoneNumber] = useState('');
    const [salt, setSalt] = useState('');
    const [code, setCode] = useState('');
    const values = { step, prefix, phone, salt, code };

    const prevStep = () => {
        setModalStep(modalStep - 1);
    }

    const nextStep = () => {
        setModalStep(modalStep + 1);
    }

    const handlePhoneNumberChange = (event) => {
        setPhoneNumber(event.target.value);
    };

    const handleCodeChange = (event) => {
        setCode(event.target.value);
    };

    useEffect(() => {
        if (user.phone) {
            const regex = new RegExp(/\(|\)|\s|\-/g);
            const phoneNumber = (user.phone).replaceAll(regex, '');

            if (phoneNumber.startsWith("+491")) {
                setPhoneNumber(phoneNumber.substring(3));
            } else if (phoneNumber.startsWith("01")) {
                setPhoneNumber(phoneNumber.substring(1));
            }
        }
    }, []);

    switch (modalStep) {
        case 1:
            return (
                <WelcomeText
                    nextStep={nextStep}
                />
            )
        case 2:
            return (
                <PhoneNumber
                    setCode={setCode}
                    setSalt={setSalt}
                    prevStep={prevStep}
                    nextStep={nextStep}
                    values={values}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                />
            )
        case 3:
            return (
                <VerificationCode
                    setCode={setCode}
                    prevStep={prevStep}
                    nextStep={nextStep}
                    values={values}
                    handleCodeChange={handleCodeChange}
                    setSalt={setSalt}
                />
            )
        case 4:
            return (
                <Success
                    step={step}
                    data={data}
                    onChange={onChange}
                    isLoading={isLoading}
                    moderationState={moderationState}
                    values={values}
                />
            )
        default:
        // do nothing
    }

}
export default ModalSteps;